module.exports = __webpack_public_path__ + "img/30.3c1cb97c.jpg";